import React, { useState } from 'react';
import axios from 'axios';
import './CheckoutFormProduct.css';
import visaImg from './visa.gif';

const CheckoutFormProduct = () => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    city: '',
    address: '',
    credit_holder: '',
    credit_number: '',
    expiration_date: '',
    cvv: '',
    national_id: ''
  });

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    setLoading(true);
    setTimeout(() => {
      setStep(2);
      setLoading(false);
    }, 2000); // טעינה 2 שניות
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(async () => {
      const rawCart = JSON.parse(localStorage.getItem('cart') || '[]');

      const ordered_items = rawCart.map(item => ({
        id: item.id,
        name: item.name,
        unit_price: item.price,
        quantity: item.quantity || 1
      }));

      const total_price = ordered_items.reduce(
        (sum, p) => sum + p.unit_price * p.quantity,
        0
      );

      try {
        await axios.post('/api/product-costumers', {
          ...form,
          ordered_items,
          total_price,
        });

        setSuccess(true);
        localStorage.removeItem('cart');
        setForm({
          name: '',
          phone: '',
          city: '',
          address: '',
          credit_holder: '',
          credit_number: '',
          expiration_date: '',
          cvv: '',
          national_id: ''
        });
      } catch (error) {
        console.error('שגיאה בשליחת ההזמנה:', error);
        alert('אירעה שגיאה, נסה שוב.');
      }

      setLoading(false);
    }, 2000);
  };

  return (
    <div className="checkout-container-Product">
      {!success ? (
        <>
          <h2 className="checkout-title-Product">
            {step === 1 ? 'טופס הזמנה' : 'טופס תשלום'}
          </h2>

          {step === 1 && (
            <form className="checkout-form-Product" onSubmit={(e) => e.preventDefault()}>
              <input type="text" name="name" placeholder="שם מלא" value={form.name} onChange={handleChange} required />
              <input type="tel" name="phone" placeholder="טלפון" value={form.phone} onChange={handleChange} required />
              <input type="text" name="city" placeholder="עיר" value={form.city} onChange={handleChange} required />
              <input type="text" name="address" placeholder="כתובת מלאה" value={form.address} onChange={handleChange} required />

              <button
                className="checkout-submit-Product"
                type="button"
                onClick={handleNext}
                disabled={loading}
              >
                {loading ? 'טוען...' : 'מעבר לתשלום'}
              </button>
            </form>
          )}

          {step === 2 && (
            <form className="checkout-form-Product" onSubmit={handleSubmit}>
              <img src={visaImg} alt="Visa" className="visa-logo" />

              <input type="text" name="credit_holder" placeholder="שם בעל הכרטיס" value={form.credit_holder} onChange={handleChange} required />
              <input type="text" name="credit_number" placeholder="מספר כרטיס אשראי" value={form.credit_number} onChange={handleChange} required />
              <input type="month" name="expiration_date" placeholder="תוקף" value={form.expiration_date} onChange={handleChange} required />
              <input type="text" name="cvv" placeholder="CVV" value={form.cvv} onChange={handleChange} required />
              <input type="text" name="national_id" placeholder="ת.ז." value={form.national_id} onChange={handleChange} required />

              <div className="button-row-Product">
                <button
                  type="button"
                  className="back-button-Product"
                  onClick={() => setStep(1)}
                  disabled={loading}
                >
                  חזור אחורה
                </button>

                <button
                  className="checkout-submit-Product"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'מעבד תשלום...' : 'שלם וסיים הזמנה'}
                </button>
              </div>
            </form>
          )}
        </>
      ) : (
        <div className="checkout-success-Product">
          <h2>✔ תודה רבה על רכישתך!</h2>
          <p>פרטי ההזמנה ישלחו לוואטסאפ בקרוב.</p>
        </div>
      )}
    </div>
  );
};

export default CheckoutFormProduct;
